<script setup>
import { computed, useSlots } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'secondary'].includes(value),
  },
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'large'].includes(value),
  },
  type: {
    type: String,
    default: 'button',
  },
})

const slots = useSlots()
const hasIcon = computed(() => Boolean(slots.icon))
</script>

<template>
  <button
    :type="props.type"
    :class="[
      'action-button',
      `action-button--${props.variant}`,
      `action-button--${props.size}`,
      { 'action-button--has-icon': hasIcon },
    ]"
  >
    <span v-if="hasIcon" class="action-button__icon">
      <slot name="icon"></slot>
    </span>
    <span class="action-button__label"><slot></slot></span>
  </button>
</template>

<style scoped>
.action-button {
  border-radius: 0.25rem;
  border: solid 1px var(--action-button-bg);
  font-weight: 600;
  font-family: inherit;
  font-size: 1.125rem;
  padding: 0.5rem 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-8);
  cursor: pointer;
  outline: 0px solid rgba(0, 0, 0, 0);
  user-select: none;
}

.action-button--primary {
  --action-button-bg: var(--semantic-bg-petrol-strong);
  background-color: var(--action-button-bg);
  color: var(--color-base-white);
  /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); */
}

.action-button--primary:hover,
.action-button--primary:focus-within {
  background-color: color-mix(in srgb, var(--action-button-bg), #000 10%);
}

.action-button--secondary {
  background: var(--semantic-bg-default);
  border: 1px solid var(--semantic-border-strong);
  color: var(--semantic-text-default);
}

.action-button--large {
  font-size: 1.25rem;
  padding: 0.65rem 2.2rem;
}

.action-button--has-icon .action-button__icon {
  display: inline-flex;
}

.action-button__icon :slotted(svg) {
  width: 32px;
  height: 32px;
  fill: currentColor;
}
</style>
